/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { CheckIcon, Combobox, Group, Pill, PillsInput, useCombobox } from "@mantine/core";
import { Timestamp } from "firebase/firestore";
import { useCallback, useEffect, useMemo, useState, type ChangeEvent, type KeyboardEvent } from "react";
import useUserStore from "@/modules/users/store";
import { useAddEmbaixador } from "./useAddEmbaixador";
import { getEmbaixador } from "../../firestore";

const message = "Ocorreu um erro ao carregar os dados:";

interface Options {
  value: string;
  label: string;
}

const EmbaixadorSelectMulti = ({ ...properties }) => {
  const colaborador = useUserStore((state) => state.colaborador);
  const empresa = useUserStore((state) => state.activeEmpresa);
  const { mutateAsync } = useAddEmbaixador();
  const [listaEmbaixadores, setListaEmbaixadores] = useState<Options[]>([]);
  const [selecao, setSelecao] = useState<string[]>([]);
  const [search, setSearch] = useState<string>("");
  const [reload, setReload] = useState<boolean>(false);
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
    onDropdownOpen: () => combobox.updateSelectedOptionIndex("active")
  });

  useEffect(() => {
    setSelecao([]);
    if (properties.form.values.embaixadores) {
      for (const item of properties.form.values.embaixadores) {
        setSelecao((previous) => [...previous, item]);
      }
    }
    // eslint-disable-next-line unicorn/explicit-length-check, react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // eslint-disable-next-line sonarjs/no-identical-functions
    const fetchData = async () => {
      try {
        await loadEmbaixador();
      } catch (error) {
        console.error(message, error);
      }
    };
    void fetchData();
    // eslint-disable-next-line unicorn/explicit-length-check, react-hooks/exhaustive-deps
  }, [empresa, reload]);

  // eslint-disable-next-line sonarjs/no-identical-functions
  const loadEmbaixador = async () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    const arrayLicenciados = await getEmbaixador(empresa?.id || "");
    const aux = arrayLicenciados.docs.map((desafio) => desafio.data());
    const data = aux
      .map((item) => ({ value: item.id, label: item.nome }))
      .sort((a, b) => a.label.localeCompare(b.label));
    setListaEmbaixadores(data);
  };

  const exactOptionMatch = listaEmbaixadores.some((item) =>
    item.label.toLowerCase().includes(search.toLowerCase().trim())
  );

  const handleValueRemove = useCallback(
    (value_: string) => {
      setSelecao((previous) => previous.filter((v) => v !== value_));
      properties?.form?.setValues((values: TProjeto) => ({
        ...values,
        embaixadores: selecao.filter((v) => v !== value_)
      }));
    },
    [properties?.form, selecao]
  );

  const itensComboBox = listaEmbaixadores
    .filter((item) => item.label.toLowerCase().includes(search.trim().toLowerCase()))
    .map((item) => (
      <Combobox.Option value={item.value} key={item.value} active={selecao.includes(item.value)}>
        <Group gap="sm">
          {selecao.includes(item.value) ? <CheckIcon size={12} /> : null}
          <span>{item.label}</span>
        </Group>
      </Combobox.Option>
    ));

  const createOption = async () => {
    try {
      const newEmbaixador = await mutateAsync({
        nome: search,
        updatedAt: Timestamp.now(),
        createdAt: Timestamp.now(),
        deletedAt: null,
        createdBy: colaborador?.id || "",
        empresaId: empresa?.id || ""
      });
      const newItem = { value: newEmbaixador.id, label: newEmbaixador.id };
      setSelecao((previous) => [...previous, newItem.value]);
      properties?.form?.setValues((values: TProjeto) => ({
        ...values,
        embaixadores: [...(values.embaixadores ?? []), newItem.value]
      }));
    } catch (error) {
      console.error("Erro ao criar novo embaixador:", error);
    } finally {
      setSearch("");
      setReload((reload) => !reload);
    }
  };

  const pillRemoveHandlers = useMemo(() => {
    const handlers = new Map<string, () => void>();
    for (const item of selecao) {
      handlers.set(item, () => handleValueRemove(item));
    }
    return handlers;
  }, [handleValueRemove, selecao]);

  const values = selecao.map((item) => {
    const option = listaEmbaixadores.find((opt) => opt.value === item);
    if (!option) {
      return null;
    }
    const handleRemove = pillRemoveHandlers.get(item)!;
    return (
      <Pill key={item} withRemoveButton onRemove={handleRemove}>
        {option?.label}
      </Pill>
    );
  });

  const handleDropdownOpen = useCallback(() => {
    combobox.openDropdown();
  }, [combobox]);

  const handleDropdownClose = useCallback(() => {
    combobox.closeDropdown();
  }, [combobox]);

  const handleSearchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      combobox.updateSelectedOptionIndex();
      setSearch(event.currentTarget.value);
    },
    [combobox]
  );

  const handleSearchKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Backspace" && search.length === 0) {
        event.preventDefault();
        handleValueRemove(selecao.at(-1) || "");
      }
      combobox.openDropdown();
    },
    [combobox, handleValueRemove, search.length, selecao]
  );

  const handleValueSelect = (value_: string) => {
    if (value_ === "$create") {
      void createOption();
    } else {
      if (selecao.includes(value_)) {
        setSearch("");
        return;
      }
      const option = listaEmbaixadores.find((item) => item.value === value_);
      if (option) {
        setSelecao((previous) => [...previous, value_]);
        properties?.form?.setValues((values: TProjeto) => ({
          ...values,
          embaixadores: [...(values.embaixadores ?? []), value_]
        }));
        setSearch("");
      }
    }
    combobox.closeDropdown();
  };

  return (
    <Combobox {...properties} store={combobox} withinPortal={false} onOptionSubmit={handleValueSelect}>
      <Combobox.DropdownTarget>
        <PillsInput onClick={handleDropdownOpen}>
          <Pill.Group>
            {values}
            <Combobox.EventsTarget>
              <PillsInput.Field
                onFocus={handleDropdownOpen}
                onBlur={handleDropdownClose}
                value={search}
                placeholder="Valor de busca"
                onChange={handleSearchChange}
                onKeyDown={handleSearchKeyDown}
              />
            </Combobox.EventsTarget>
          </Pill.Group>
        </PillsInput>
      </Combobox.DropdownTarget>
      <Combobox.Dropdown>
        <Combobox.Options>
          {itensComboBox}
          {!exactOptionMatch && search.trim().length > 0 && (
            <Combobox.Option value="$create">
              + Criar <b>{search}</b>
            </Combobox.Option>
          )}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};
// eslint-disable-next-line import/no-unused-modules
export default EmbaixadorSelectMulti;
